import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { selectAppConfig } from '../../redux/appConfigReducer';
import { VEHICLE_BY_CARLINE } from '../../schemas/VehicleByCarline';
import { oneGraphClient } from '../../constants/environment';

const useFetchByCarline = (carline: string | null, market: string) => {
  const marketForApi = market === 'USA' ? 'us' : 'ca';

  const { loading, data, error } = useQuery(VEHICLE_BY_CARLINE, {
    fetchPolicy: 'no-cache',
    client: oneGraphClient,
    skip: !carline,
    variables: {
      carlineInput: {
        brand: 'A',
        carlineId: carline,
        country: marketForApi,
        language: 'en',
      },
      filterInput: {
        filterByProfileId: 'EXTERIOR-FRONT-3-4-ENV1',
      },
    },
  });

  const vehicleCarlineDetails = useMemo(() => {
    if (!data) return undefined;
    return {
      titleText: data?.configuredCarByCarline?.carline?.name?.replace(/^Audi\s*/i, ''),
      model: {
        salesModelyear: data?.configuredCarByCarline?.model?.id?.year,
      },
      subtitleText: data?.configuredCarByCarline?.model?.name,
      images: [
        {
          url: data?.configuredCarByCarline?.media?.images[0]?.url,
        },
      ],
    };
  }, [data]);

  return { vehicleCarlineDetails, isCarlineVehicleLoading: loading };
};

export default useFetchByCarline;
